// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const DescriptionIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="DescriptionIcon" ref={forwardedRef} {...props}>
      <path d="M7 9.25h6v1.5H7z" />
      <path d="M13 12.75H7v1.5h6z" />
      <path d="M5 2h7.072L16 5.555V17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1m9.5 5.5h-4.25v-4H5.5v13h9zM14.259 6 11.75 3.733V6z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const DescriptionIcon = /* @__PURE__ */ Object.assign(
  DescriptionIconComponent,
  { displayName: 'DescriptionIcon' },
);
